// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  receiptId: __t.u64().primaryKey().name("receipt_id"),
  workspaceId: __t.u64().name("workspace_id"),
  kind: __t.string(),
  subjectKind: __t.string().name("subject_kind"),
  subjectId: __t.u64().name("subject_id"),
  title: __t.string(),
  bodyMd: __t.string().name("body_md"),
  evidenceRefsJson: __t.string().name("evidence_refs_json"),
  authorAgentId: __t.option(__t.u64()).name("author_agent_id"),
  taskTagsJson: __t.string().name("task_tags_json"),
  costMicros: __t.i64().name("cost_micros"),
  scoreDeltaJson: __t.string().name("score_delta_json"),
  supersededBy: __t.option(__t.u64()).name("superseded_by"),
  createdAt: __t.i64().name("created_at"),
});
